import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { logoutUser } from "./common";
import StandingOrderService from "../service/StandingOrderService";
import { GetTraderParamModel } from "../model/common";
import { RootState } from "../store/store";

export const resetStandingOrders = createAction("standingOrders/reset");

const _service = new StandingOrderService();

type SliceState = {
  // details: IStandingOrderInfo | null;
  details: any | null;
  addedList: any;
  changedOrder: any;
  status: string;
  saveResponse: any;
  traderId: number;
  filteredDaysPerItem: any | null;
  removedItemList: any | null;
  apiCallCount: number;
  viewType: boolean;
  addressSelected: any;
  minimumOrder: any;
};

const initialState = {
  details: null,
  addedList: [],
  changedOrder: [],
  status: COMMON_STATUS.INITIAL,
  saveResponse: null,
  traderId: 0,
  filteredDaysPerItem: [],
  removedItemList: [{ itemId: -1, newItem: false }],
  apiCallCount: 0,
  viewType: true,
  addressSelected: null,
  minimumOrder: 0,
} as SliceState;

export const getStandingOrderDetailsAsync = createAsyncThunk(
  "standingOrder/getStandingOrderDetails",
  async (params: any) => {
    const response = await _service.getStandingOrderDetailsService(params);
    return response;
  }
);

export const saveStandingOrdersAsync = createAsyncThunk(
  "standingOrder/saveStandingOrderA",
  async (params: any) => {
    const response = await _service.saveStandingOrdersService(params);
    return response;
  }
);

export const standingOrdersSlice = createSlice({
  name: "standingOrder",
  initialState,
  reducers: {
    setCurrentStandingOrders: (state, action) => {
      state.status = action.payload;
    },
    setTraderId: (state, action) => {
      state.traderId = action.payload;
    },
    addItemToSOList: (state, action) => {
      if (state.addedList) {
        const tempList = state.addedList;
        const tempObj = action.payload;

        const existingItem = tempList.findIndex(
          (item: any) => item.item.id === tempObj.item.id
        );

        if (existingItem !== -1) {
          tempList[existingItem] = tempObj;
        } else {
          tempList.push(tempObj);
        }

        state.addedList = [...tempList];
      } else {
        state.addedList = [action.payload];
      }
    },
    newRemovedItemList: (state, action) => {
      // console.log(action.payload);
      state.removedItemList = [...action.payload];
    },
    addRemovedItemList: (state, action) => {
      const itemRemoved = action.payload;
      const tempRemovedItems: any = [...state.removedItemList];
      const tempNewItems: any = [];

      state.addedList.forEach((addedItem: any) => {
        if (itemRemoved.itemId !== addedItem.item.id) {
          tempNewItems.push(addedItem);
        }
      });

      // console.log(tempNewItems);

      state.addedList = [...tempNewItems];

      if (!itemRemoved.newItem) {
        if (
          tempRemovedItems.some(
            (item: any) => item.itemId === itemRemoved.itemId
          )
        ) {
        } else {
          tempRemovedItems.push(itemRemoved);
          state.removedItemList = [...tempRemovedItems];
        }
      }
    },
    removeAddedItemToSOList: (state, action) => {
      state.addedList = action.payload;
    },
    
    addFilteredItems: (state, action) => {
      state.filteredDaysPerItem = action.payload;
    },
    changeViewType: (state, action) => {
      state.viewType = action.payload;
    },
    newChangedOrder: (state, action) => {
      state.changedOrder = [...action.payload];
    },
    addChangedOrder: (state, action) => {
      const tempVal = action.payload;
      const tempList = [...state.changedOrder];

      if (
        tempList.some(
          (item: any) =>
            item.itemId === tempVal.itemId && item.day === tempVal.day
        )
      ) {
        [...tempList].forEach((item: any, i: number) => {
          if (item.itemId === tempVal.itemId && item.day === tempVal.day) {
            tempList[i] = { ...tempVal };
          }
        });
      } else {
        tempList.push(action.payload);
      }

      state.changedOrder = [...tempList];
    },

    
    removedChangedOrderOne: (state, action) => {
      const tempList = [...state.changedOrder];

      state.changedOrder.forEach((item: any, i: number) => {
        if (
          item.itemId === action.payload.itemId &&
          item.day === action.payload.day
        )
          tempList.splice(i, 1);
      });

      state.changedOrder = [...tempList];
    },
    removedChangedOrderMany: (state, action) => {
      const tempList = [...state.changedOrder];
    },
    removeChangedOrderWithID: (state, action) => {
      const tempList = [...state.changedOrder].filter(
        (obj: any) => obj.itemId !== action.payload
      );

      state.changedOrder = [...tempList];
    },
    removeChangedOrderWithDay: (state, action) => {
      const tempList = [...state.changedOrder].filter(
        (obj: any) => obj.day !== action.payload
      );

      state.changedOrder = [...tempList];
    },
    changeAddressSelected: (state, action) => {
      state.addressSelected = action.payload;
    },
    addChangedOrderForAddItems: (state, action) => {
      const tempNewOrders = [...action.payload];
      const tempOrders = [...state.changedOrder];

      tempNewOrders.forEach((order: any) => {
        const tempValue = { ...order };
        // console.log(tempValue);

        if (
          tempOrders.some(
            (item: any) =>
              item.itemId === tempValue.itemId && item.day === tempValue.day
          )
        ) {
          const tempList1 = [...tempOrders];

          tempList1.forEach((obj0: any, k: number) => {
            if (
              obj0.itemId === tempValue.itemId &&
              obj0.day === tempValue.day
            ) {
              tempOrders.splice(k, 1, tempValue);
            }
          });
        } else {
          tempOrders.push(tempValue);
        }
      });

      state.changedOrder = [...tempOrders];
    },
    updateStandingOrderReason: (state, action) => {
      state.details.traderLive = action.payload;
    },
    clearSaveResponse: (state) => {
      state.saveResponse = null;
    },

    clearPiecesPerDayInAddedList: (state) => {
      state.filteredDaysPerItem = state.filteredDaysPerItem.map((item: any) => ({
        ...item,
        // Reset piecesPerDay to all nulls
        piecesPerDay: Array.isArray(item.piecesPerDay)
          ? item.piecesPerDay.map(() => null)
          : [],
        // Reset ordersPerDay counts
        ordersPerDay: Array.isArray(item.ordersPerDay)
          ? item.ordersPerDay.map((order: any) => ({
              ...order,
              orderedCount: null,
              newOrderedCount: null,
            }))
          : [],
      }));
    },

  },
  extraReducers: (builder) => {
    builder
      // GET SO
      .addCase(getStandingOrderDetailsAsync.pending, (state: SliceState) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(
        getStandingOrderDetailsAsync.fulfilled,
        (state: SliceState, action) => {
          state.details = action.payload;
          // state.minimumOrder = action.payload.details?.listOfStandingOrderDetails?.address?.minimumOrder;
          state.status = COMMON_STATUS.LOADED;
        }
      )
      .addCase(getStandingOrderDetailsAsync.rejected, (state: SliceState) => {
        state.status = COMMON_STATUS.FAILED;
      })

      // SAVE SO
      .addCase(saveStandingOrdersAsync.pending, (state: SliceState) => {
        state.status = COMMON_STATUS.LOADING;
      })

      .addCase(saveStandingOrdersAsync.fulfilled, (state, action) => {
        state.saveResponse = action.payload;
        state.status = COMMON_STATUS.LOADED;
        if (action.payload?.success === false) {
          if (state.filteredDaysPerItem?.rows) {
            state.filteredDaysPerItem.rows = state.filteredDaysPerItem.rows.map((row: any) => {
              const updatedOrdersPerDay = Array.isArray(row.ordersPerDay)
                ? row.ordersPerDay.map((order: any) => ({
                    ...order,
                    orderedCount: 0,
                    newOrderedCount: null,
                  }))
                : [];

              return {
                ...row,
                ordersPerDay: updatedOrdersPerDay,
                quantities: Array.isArray(row.quantities)
                  ? row.quantities.map(() => null)
                  : row.quantities,
              };
            });
          }
        }
      })

      .addCase(saveStandingOrdersAsync.rejected, (state: SliceState) => {
        state.status = COMMON_STATUS.FAILED;
      })

      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetStandingOrders, () => {
        return initialState;
      });
  },
});

export const {
  setCurrentStandingOrders,
  setTraderId,
  addItemToSOList,
  newRemovedItemList,
  addRemovedItemList,
  removeAddedItemToSOList,
  addFilteredItems,
  changeViewType,
  addChangedOrder,
  removedChangedOrderOne,
  removedChangedOrderMany,
  newChangedOrder,
  removeChangedOrderWithID,
  removeChangedOrderWithDay,
  changeAddressSelected,
  addChangedOrderForAddItems,
  updateStandingOrderReason,
  clearPiecesPerDayInAddedList,
  clearSaveResponse
} = standingOrdersSlice.actions;

export const getStandingOrderDetails = (state: RootState) =>
  state.standingOrder;

export const getViewType = (state: RootState) => state.standingOrder.viewType;

export const getItemRemovedList = (state: RootState) =>
  state.standingOrder.removedItemList;

export const getChangedOrder = (state: RootState) =>
  state.standingOrder.changedOrder;

export const saveStandingOrderA = (state: RootState) => state.standingOrder;

export const getStandingOrderAddedList = (state: RootState) =>
  state.standingOrder.addedList;

export const getStandingOrderFilteredList = (state: RootState) =>
  state.standingOrder.filteredDaysPerItem;

export const getAddressSelected = (state: RootState) =>
  state.standingOrder.addressSelected;

export const getSOdetails = (state: RootState) =>
  state.standingOrder.details;

export const getSOStatus = (state: RootState) => state.standingOrder.status;

export default standingOrdersSlice.reducer;
